module.exports = __webpack_public_path__ + "static/normal-ce393f7cb8c6123e45f0208d6a976ba5.png";